// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesDown } from "@fortawesome/free-solid-svg-icons";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";

interface SubHeaderHomeProps {
    agencyName?: string;
    isSeo: boolean;
    showSearchForm?: boolean;
    loaderFinish: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
    showSearchForm = true /* Default a true se non specificato*/,
    loaderFinish
}) => {

    const LARGE_FILES_URL = import.meta.env.VITE_LARGE_FILES_BASE_URL;

    const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
    const { t } = useTranslation();

    // Il video carica sempre al mount, ma quando cambia la props del loader lo fa ripartire da capo
    const videoRef = useRef<HTMLVideoElement>(null);

    const handleVideoStart = () => {
        if (videoRef.current) {
            videoRef.current.play().catch((error) => {
                console.error("Errore durante la riproduzione del video:", error);
            });
        }
    }

    useEffect(() => {
        handleVideoStart();
    }, [])

    useEffect(() => {
        if (loaderFinish) {
            videoRef.current?.pause();
            if (videoRef.current) {
                videoRef.current.currentTime = 0;
            }
            handleVideoStart();
        }
    }, [loaderFinish]);

    // console.log(loaderFinish, "loaderFinish in SubHeaderHome.tsx");

    // -----------------------------------------------------------------------------------------------------

    // Transizione per rendere visibile il text wrapper
    const [boxVisible, setBoxVisible] = useState(false);

    useEffect(() => {
        const handleVisible = () => {
            setBoxVisible(true)
        };

        const timer = setTimeout(handleVisible, 3000);
        return () => clearTimeout(timer);
    }, [])

    // Rendering Componente
    if (loading) return <LoadingIndicator />;
    if (error) return <SlowLoadComponent />;
    if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

    return (
        <section className="banner bg-overlay-black-70">

            <video
                ref={videoRef}
                muted
                autoPlay
                loop
                playsInline
                preload="metadata"
                poster="/assets/images/inHome/copertina.jpg"
                onLoadedData={handleVideoStart}
            >
                <source src={`${LARGE_FILES_URL}/hero-video.mp4`} type="video/mp4" />
            </video>
            <div className="container-fluid">
                <div className={`text-wrapper ${boxVisible ? 'visible' : ''}`}>
                    <h1 className="text-center" dangerouslySetInnerHTML={{ __html: t('homePage.hero.title') as string }}></h1>
                    <div className="row justify-content-center">
                        <div className="col-12 col-xl-9">
                            {showSearchForm && <PropertySearchField searchData={{}} />}
                        </div>
                    </div>
                </div>
            </div>

            {false && (
                <>
                    <img src="/assets/images/inHome/hero.webp" alt={t('homePage.hero.altImage') as string} />
                    <div className="scroll-indicator">
                        <a href="#search-box" title={t('homePage.hero.scrollDownTitle') as string}>
                            <FontAwesomeIcon icon={faAnglesDown} />
                        </a>
                    </div>
                </>
            )}
        </section>
    );
};

export default SubHeaderHome;